import { render, staticRenderFns } from "./KT-CustomMultiSelect.vue?vue&type=template&id=2c81945c&scoped=true&lang=pug&"
import script from "./KT-CustomMultiSelect.vue?vue&type=script&lang=js&"
export * from "./KT-CustomMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./KT-CustomMultiSelect.vue?vue&type=style&index=0&id=2c81945c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81945c",
  null
  
)

export default component.exports